import React, { useMemo, useState } from "react";

import ShipeeziGrid, { Column } from "Components/AppGrid/shipeezi-new-grid";
import { useTranslation } from "react-i18next";
import { FiLink2 } from "react-icons/fi";

import { PurchaseOrder } from "../../../../../../../models/purchase.order";
import { formatDateWithoutTimeZone } from "../../../../../../../util/Format";
import { paginate } from "../../../../../../../util/paginate";
import useStyles from "./styles";

interface Props {
  orders: any[];
}

const InvoiceOrders = (props: Props) => {
  const { orders } = props;
  const { t: translate } = useTranslation();
  const classes = useStyles();

  const [page, setPage] = useState<number>(0);
  const [pageSize, setPageSize] = useState<number>(20);

  const purchaseOrderData = useMemo(() => {
    const data = orders ?? [];

    return paginate(data, page > 0 ? page - 1 : 0, pageSize);
  }, [orders, page, pageSize]);

  const renderReferenceFromIntegration = (reference: string, order: PurchaseOrder) => {
    if (!order.fromIntegration) return reference;

    return (
      <div className={classes.row}>
        <span>{reference}</span>
        <FiLink2 color="#38CFC4" size={15} />
      </div>
    );
  };

  const columns: Column[] = [
    {
      name: "reference",
      title: `${translate("order")}#`,
      formatComponent: renderReferenceFromIntegration,
      hideSort: true,
      searchIdentifier: "reference",
    },
    {
      name: "supplierName",
      title: translate("supplierName"),
      hideSort: true,
    },
    {
      name: "origin",
      title: translate("origin"),
      hideSort: true,
    },
    {
      name: "destination",
      title: translate("destination"),
      hideSort: true,
    },
    {
      name: "eta",
      title: translate("shipByDate"),
      formatText: (value?: string) => formatDateWithoutTimeZone(value),
      hideSort: true,
      hideSearch: true,
    },
    {
      name: "etd",
      title: translate("etd"),
      hideSort: true,
    },
    {
      name: "mode",
      title: translate("mode"),
      hideSort: true,
      formatComponent: (value: string) =>
        value ? translate(value.toLowerCase()) : "",
    },
  ];

  return (
    <div>
      <ShipeeziGrid
        data={purchaseOrderData}
        totalItems={orders.length}
        columns={columns}
        emptyData={translate("noInformationToBeShown")}
        currentPage={page}
        onNextPage={setPage}
        onPreviousPage={setPage}
        onGoToPage={setPage}
        pageSize={pageSize}
        onChangePageSize={setPageSize}
        pageSizeList={[20, 40, 60, 100]}
      />
    </div>
  );
};

export default InvoiceOrders;
